import { Control } from 'react-hook-form';
import ControlledSelect from 'components/ControlledSelect';
import { ToolbarFields } from 'components/FilterSummary';
import {
  ClientsData,
  FilterOption,
  ProjectsData,
} from 'utils/helpers/renameKeys';
import { BusinessTripsFilters } from './types';

interface BusinessTripPickersProps {
  control: Control<BusinessTripsFilters>;
  clients: ClientsData[];
  projects: ProjectsData[];
  employees: FilterOption[];
  setValue: (name: string, value: string) => void;
  showEmployeeFilter: boolean;
  loading: boolean;
}

// Client, project and employee pickers; they sit in the table's top row,
// beside the paging stats. Each sits in a box that sets its width, because
// react-select overrides its own container width inline.
const BusinessTripPickers = ({
  control,
  clients,
  projects,
  employees,
  setValue,
  showEmployeeFilter,
  loading,
}: BusinessTripPickersProps) => (
  <ToolbarFields>
    <div>
      <ControlledSelect
        label="TABLE.HEAD.CLIENT"
        name="client"
        control={control}
        options={clients}
        isDisabled={loading}
        isSmall
        isPadding={false}
        handleChange={() => setValue('project', '')}
      />
    </div>
    <div>
      <ControlledSelect
        label="TABLE.HEAD.PROJECT"
        name="project"
        control={control}
        options={projects}
        isDisabled={loading}
        isSmall
        isPadding={false}
      />
    </div>
    {showEmployeeFilter && (
      <div>
        <ControlledSelect
          label="TABLE.HEAD.NAME"
          name="employee"
          control={control}
          options={employees}
          isDisabled={loading}
          isSmall
          isPadding={false}
        />
      </div>
    )}
  </ToolbarFields>
);

export default BusinessTripPickers;
